import { ResultContent } from '@/shared/components';
import { Trans, useTranslation } from 'react-i18next';
import { ModalComponentWrapper } from '@/shared/components';
import { useModalStore } from '@/shared/lib';
import type { CreateApiTokenResponseDto } from './types';
import { CreateApiTokenResultDetails } from '../ui';

type SuccessScreenProps = {
  apiToken: CreateApiTokenResponseDto;
  onBack: () => void;
};

const useCreateApiTokenResult = () => {
  const { showDialogComponent } = useModalStore();
  const { t } = useTranslation();

  const goToSuccessScreen = ({ apiToken, onBack }: SuccessScreenProps) => {
    if (!apiToken) return;

    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess
            onClick={onBack}
            title={t('webApiTokens.creation.success.title')}
            description={
              <Trans
                i18nKey="webApiTokens.creation.success.description"
                components={{
                  bold: <span className="font-semibold text-primary" />,
                  br: <br />,
                }}
              />
            }
            buttonText={t('webApiTokens.creation.success.buttonText')}
            buttonVariant="secondary"
            className="h-auto"
            contentClassName="pt-[0.6rem] pb-[2.4rem] sm:pt-0 sm:pb-[3.2rem] max-w-none">
            <CreateApiTokenResultDetails apiToken={apiToken} />
          </ResultContent>
        </ModalComponentWrapper>
      ),
    });
  };

  return {
    goToSuccessScreen,
  };
};

export { useCreateApiTokenResult };
